export default new class SubscriptionSelectCustom {
    constructor() {
        this.subscriptionSelectWrappers = document.querySelectorAll('.subscription__select__wrapper');

        if (this.subscriptionSelectWrappers.length != 0) {
            for (const selectWrapper of this.subscriptionSelectWrappers) {
                this.bind(selectWrapper);
            }
        }
    }

    bind(selectWrapper) {
        let title = selectWrapper.querySelector('.subscription__select__title')
        let selectContent = selectWrapper.querySelector('.subscription__select__content')
        this.initDefaultSelect (selectWrapper)
        this.handleSubscriptionSelectTitle(selectWrapper, title, selectContent)
        this.handleSelectOption (title, selectContent)
    }

    initDefaultSelect (selectWrapper) {
        let options = Array.from(selectWrapper.querySelectorAll('.subscription__select__option'))
        let checkedOption = options.find((option) => option.checked)
        const result = checkedOption.closest('.price-table__cell').querySelector('.subscription-select-result')
        let offerId = checkedOption.getAttribute('data-offer-id')
        let periodId = checkedOption.getAttribute('data-period-id')
        let journal = checkedOption.getAttribute('data-journal')

        if (offerId) {
            result.setAttribute('data-offer-id', offerId);
        }

        if (periodId) {
            result.setAttribute('data-period-id', periodId);
        }

        if (journal) {
            result.setAttribute('data-journal', journal);
        }
    }

    handleSubscriptionSelectTitle(selectWrapper, title, selectContent) {
        title.addEventListener('click', () => {
            if (selectContent.style.display == "none") {
                selectContent.style.display = "flex"
                title.classList.add('openned')
            } else {
                selectContent.style.display = "none"
                title.classList.remove('openned')
            }
        })

        document.addEventListener( 'click', (e) => {
            const clickOutOfTitle = !e.composedPath().includes(selectWrapper)
            const selectWasOppened = title.classList.contains("openned")
            if (clickOutOfTitle && selectWasOppened) {
                title.classList.remove("openned")
                selectContent.style.display = 'none'
            }
        })

        document.addEventListener( 'keydown', (e) => {
            const selectWasOppened = title.classList.contains("openned")
            if (e.key == "Escape" && selectWasOppened) {
                title.classList.remove("openned")
                selectContent.style.display = 'none'
            }
        })
    }

    handleSelectOption (title, selectContent) {

        let options = selectContent.querySelectorAll('.subscription__select__option__wrapper')
        for (let option of options) {
            let label = option.querySelector("label")
            label.addEventListener ('click', (e) => {
                title.innerHTML = label.innerHTML
                selectContent.style.display = "none"
                title.classList.remove('openned')
                this.writeSelectResult (option)
            })
        }
    }

    writeSelectResult (option) {
        const result = option.closest('.price-table__cell').querySelector('.subscription-select-result')
        const input = option.querySelector('input')

        let offerId = input.getAttribute('data-offer-id')
        let periodId = input.getAttribute('data-period-id')
        let journal = input.getAttribute('data-journal')

        if (journal) {
            result.setAttribute('data-journal', journal);
        }

        if (offerId) {
            result.setAttribute('data-offer-id', offerId);
        }

        if (periodId) {
            result.setAttribute('data-period-id', periodId);
        }

        let context = this

        $.request('LandingPage::onChangeOfferSelect', {
        data: result.dataset,
        success: function(data) {
            context.changePrice(option, data)
        },
        async: false,
        });
    }

    changePrice(option, data) {
        let priceWrapper = option.closest('.price-table__cell').querySelector('.price-table__cell__price__wrapper')

        if (data.subs_price !== "0,00" && data.subs_price !== 0 && data.subs_price !== "0.00") {
          priceWrapper.innerHTML = `
          <span class="price-table__cell__discount-promo">Выгода более 30%</span>
          <span class="price-table__cell__price">${data.price } р.</span>
          <span class="price-table__cell__discount-old">${data.subs_price } р.</span>
          `
        } else {
          priceWrapper.innerHTML = `
          <span class="price-table__cell__price">${data.price } р.</span>
          `
        }
    }
}
